import { ui } from '@beelday/common'
import styled from '@emotion/styled'
import ScriptActivityDescription from 'features/script/script-activity-description'
import { Activity, activityIconType } from 'features/script/script-model'
import { FC } from 'react'
import { ActivityGroup } from '../model/agenda-outline'

const Chips = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 4px 10px;
	font-size: 12px;
`

const Chip = styled.div<{ current: boolean }>`
	display: flex;
	align-items: center;
	gap: 5px;
	font-weight: ${({ current }) => (current ? 700 : 400)};
`

const Line = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	font-size: 13px;
`

/** One agenda row's tools: "Slide ×6", or "Slide 3 / 6" while the third is on. */
export const ActivityChips: FC<{ groups: ActivityGroup[] }> = ({ groups }) =>
	groups.length ? (
		<Chips>
			{groups.map((group, index) => (
				<Chip key={index} current={group.position === 'current'}>
					<ui.ActivityIcon type={activityIconType(group.activity)} size={18} />
					<ScriptActivityDescription activity={group.activity} />
					{group.count > 1
						? group.currentNumber
							? ` ${group.currentNumber} / ${group.count}`
							: ` ×${group.count}`
						: null}
				</Chip>
			))}
		</Chips>
	) : null

/** The tool on now. */
export const ActivityLine: FC<{ activity: Activity }> = ({ activity }) => (
	<Line>
		<ui.ActivityIcon type={activityIconType(activity)} />
		<ScriptActivityDescription activity={activity} />
	</Line>
)
